module.exports = __webpack_public_path__ + "img/Nonmotor_acc_4.3ecca358.jpg";